import { API } from "../../apiSlice";

export const getGraphDataApiSlice = API.injectEndpoints({
  endpoints: (builder) => ({
    getGraphData: builder.query({
      query: () => {
        return {
          url: "users/graph-data",
        };
      },
    }),
  }),
});

export const { useGetGraphDataQuery } = getGraphDataApiSlice;
